const DOWNLOADED_BOOK_IDS_KEY = 'shelfmark:downloaded-book-ids:v1';
const MAX_REMEMBERED_BOOKS = 2000;

interface StorageLike {
  getItem(key: string): string | null;
  setItem(key: string, value: string): void;
}

function browserStorage(): StorageLike | null {
  try {
    return typeof window === 'undefined' ? null : window.localStorage;
  } catch {
    return null;
  }
}

export function loadDownloadedBookIds(
  storage: StorageLike | null = browserStorage(),
): Set<string> {
  if (!storage) return new Set();

  try {
    const stored = JSON.parse(storage.getItem(DOWNLOADED_BOOK_IDS_KEY) ?? '[]');
    if (!Array.isArray(stored)) return new Set();
    return new Set(
      stored
        .filter((bookId): bookId is string => typeof bookId === 'string' && bookId.length > 0)
        .slice(-MAX_REMEMBERED_BOOKS),
    );
  } catch {
    return new Set();
  }
}

export function rememberDownloadedBookId(
  currentBookIds: Set<string>,
  bookId: string,
  storage: StorageLike | null = browserStorage(),
): Set<string> {
  const normalizedBookId = bookId.trim();
  if (!normalizedBookId) return currentBookIds;

  // Reinsert existing IDs so the cap keeps the most recently completed books.
  const nextBookIds = new Set(currentBookIds);
  nextBookIds.delete(normalizedBookId);
  nextBookIds.add(normalizedBookId);
  const cappedBookIds = new Set(Array.from(nextBookIds).slice(-MAX_REMEMBERED_BOOKS));

  if (storage) {
    try {
      storage.setItem(DOWNLOADED_BOOK_IDS_KEY, JSON.stringify(Array.from(cappedBookIds)));
    } catch {
      // Storage can be unavailable or full; keep the in-memory state working.
    }
  }

  return cappedBookIds;
}

